import posthog, {PostHogConfig} from 'posthog-js'
import {PostHogProvider} from 'posthog-js/react'

const options: Partial<PostHogConfig> = {
  api_host: 'https://portal-ph-proxy.app.vionlabs.com/ingest',
  capture_pageview: false,
  capture_pageleave: true,
  person_profiles: 'identified_only',
  loaded: () => {
    if (process.env.NODE_ENV === 'production') return

    posthog.opt_out_capturing()
    posthog.stopSessionRecording()
  },
}

export function ClientAnalyticsProvider({children}: {children: Readonly<React.ReactNode>}) {
  return (
    <PostHogProvider
      apiKey='phc_WZsd9IcBl4dsNQ5NlUH1OuvKyZxfgfN14uNrnTUSHvM'
      options={options}
    >
      {children}
    </PostHogProvider>
  )
}
